"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalleryPlayButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MosaicIcon_1 = require("../../../../Shared/Components/MosaicIcon");
const GalleryPlayButton = ({ url, onClick, playButtonAriaLabel, onVideoSlideKeyPress, }) => {
    if (!url)
        return null;
    return ((0, jsx_runtime_1.jsx)("button", { "aria-label": playButtonAriaLabel, onClick: e => onClick(e, url), onKeyPress: onVideoSlideKeyPress, className: "play-video-button text-primary bg-fill-primary border-primary hover:bg-fill-primary-hovered active:bg-fill-primary-pressed p-sm m-md md:m-3xl absolute bottom-0 left-0 flex items-center justify-center rounded-2xl border z-2", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "play-arrow-outline" }) }));
};
exports.GalleryPlayButton = GalleryPlayButton;
